import { useState, useEffect } from 'react';

const useTypewriter = (strings = [], typingSpeed = 78, deletingSpeed = 44, pauseTime = 1600) => {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!strings.length) return;
    let si = 0, ci = 0, deleting = false;
    let timer;

    const tick = () => {
      const cur = strings[si];
      if (!deleting && ci < cur.length) {
        ci++;
        setText(cur.slice(0, ci));
        timer = setTimeout(tick, typingSpeed);
      } else if (!deleting && ci === cur.length) {
        timer = setTimeout(() => { deleting = true; tick(); }, pauseTime);
      } else if (deleting && ci > 0) {
        ci--;
        setText(cur.slice(0, ci));
        timer = setTimeout(tick, deletingSpeed);
      } else {
        deleting = false;
        si = (si + 1) % strings.length;
        timer = setTimeout(tick, 200);
      }
    };

    tick();
    return () => clearTimeout(timer);
  }, [strings, typingSpeed, deletingSpeed, pauseTime]);

  return text;
};

export default useTypewriter;
